<template>
  <div class="document-search-result">
    <div class="document-search-result__header">
      <p>
        {{ header }}
      </p>
      <div>
        <span v-if="filetype">
          {{ filetype }}
        </span>
        <span
          v-if="visibility"
          :class="[
            'document-search-result__visibility',
            `document-search-result__visibility--${visibility}`
          ]"
        >
          {{ setVisibilityText }}
        </span>
      </div>
    </div>
    <a :href="url" class="document-search-result__title">
      {{ title }}
    </a>
    <p class="document-search-result__body">
      <slot name="content"></slot>
    </p>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    header: {
      type: String
    },
    filetype: {
      type: String
    },
    visibility: {
      type: String
    },
    title: {
      type: String
    },
    url: {
      type: String
    },
    content: {
      type: String
    }
  },
  computed: {
    setVisibilityText() {
      return this.visibility === 'staff' ? 'Staff Only' : this.visibility
    }
  }
}
</script>

<style scoped lang="scss">
@import '@nextrequestco/components/src/styles/colors.scss';

.document-search-result {
  font-size: 12px;
  padding: 12px;
  position: relative;

  &__header {
    color: $grey;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    line-height: 18px;
  }

  &__visibility {
    font-weight: bold;
    margin-left: 4px;
    text-transform: capitalize;
    &--staff {
      color: $grey;
    }
    &--requester {
      color: $blue;
    }
    &--public {
      color: $green;
    }
  }

  &__title {
    display: block;
    font-size: 16px;
    line-height: 24px;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      border: 1px solid $white-ter;
    }

    &:hover {
      color: inherit;
    }

    &:focus {
      color: $blue;
      outline: none;
    }

    &:hover,
    &:focus {
      &::after {
        box-shadow:
          0px 10px 20px rgba(9, 9, 11, 0.19),
          0px 6px 6px rgba(9, 9, 11, 0.23);
      }
    }
  }

  &__body {
    color: $grey;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    // Currently the default Elasticsearch result tag
    em {
      font-style: normal;
      color: $grey-darker;
      background-color: rgba(63, 83, 218, 0.25);
    }
  }
}
</style>
